<template>
  <div>
    <ux-upload-files></ux-upload-files>
  </div>
</template>

<script>
import UxUploadFiles from "./UxUploadFiles";
export default {
  components: { UxUploadFiles },
  data() {
    return {};
  },
  created() {},
  methods: {},
  filters: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
</style>
